var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_499_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.594 2.4C6.594 2.68 6.496 2.89 6.3 3.044C6.09 3.212 5.852 3.282 5.586 3.282C5.502 3.282 5.348 3.268 5.096 3.24C4.83 3.212 4.634 3.198 4.522 3.198C4.298 3.198 4.074 3.226 3.822 3.268C4.046 3.52 4.354 3.772 4.76 3.996C5.082 4.192 5.306 4.332 5.418 4.43C5.614 4.626 5.712 4.864 5.712 5.116C5.712 5.34 5.628 5.536 5.488 5.676C5.32 5.844 5.138 5.914 4.914 5.914C4.41 5.914 4.088 5.48 3.92 4.612C3.822 4.164 3.682 3.786 3.5 3.492C3.304 3.786 3.164 4.164 3.08 4.612C2.912 5.48 2.576 5.914 2.086 5.914C1.862 5.914 1.666 5.844 1.512 5.676C1.358 5.536 1.288 5.34 1.288 5.116C1.288 4.864 1.386 4.626 1.582 4.43C1.694 4.332 1.904 4.192 2.24 3.996C2.632 3.772 2.954 3.52 3.178 3.268C2.926 3.226 2.688 3.198 2.478 3.198C2.352 3.198 2.156 3.212 1.904 3.24C1.652 3.268 1.484 3.282 1.414 3.282C1.134 3.282 0.896 3.212 0.7 3.044C0.504 2.89 0.406 2.68 0.406 2.4C0.406 2.19 0.49 2.008 0.658 1.868C0.826 1.728 1.008 1.644 1.232 1.644C1.512 1.644 1.862 1.854 2.31 2.26C2.618 2.554 2.94 2.778 3.304 2.918C3.262 2.526 3.164 2.148 2.996 1.784C2.786 1.35 2.688 1.042 2.688 0.859999C2.688 0.622 2.758 0.411999 2.912 0.244C3.066 0.0759994 3.262 -0.00800037 3.5 -0.00800037C3.724 -0.00800037 3.92 0.0759994 4.088 0.244C4.228 0.411999 4.312 0.622 4.312 0.859999C4.312 1.042 4.2 1.35 4.004 1.784C3.836 2.148 3.724 2.526 3.696 2.918C4.046 2.778 4.382 2.554 4.69 2.26C5.124 1.854 5.488 1.644 5.768 1.644C5.978 1.644 6.174 1.728 6.342 1.868C6.51 2.008 6.594 2.19 6.594 2.4Z",
    fill: "#FF4D4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_499_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequired);
export default __webpack_public_path__ + "static/media/Required.e5e5d7b47d0ebb8b03b37b1289336be0.svg";
export { ForwardRef as ReactComponent };